<template>
  <section>
    <fixed-header title="Reports" />
    <b-card class="h-100" body-class="margin-top-fixed-header">
      <b-card no-body class="mb-3" v-for="(list, i) in reportsList" :key="i">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle="'accordion-'+i" variant="info">{{ list.title }}</b-button>
        </b-card-header>
        <b-collapse :id="'accordion-'+i" visible :accordion="'my-accordion-'+i" role="tabpanel">
          <b-row>
            <b-col>
              <b-list-group v-for="(report, j) in list.reports.filter((k,l) => l % 2 == 0)" :key="j">
                <b-list-group-item :to="getLink(report.token)">{{ report.display }}</b-list-group-item>
              </b-list-group>
            </b-col>
            <b-col>
              <b-list-group v-for="(report, j) in list.reports.filter((k,l) => l % 2 == 1)" :key="j">
                <b-list-group-item :to="getLink(report.token)">{{ report.display }}</b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
          
        </b-collapse>
      </b-card>
      
    </b-card>
  </section>  
</template>

<script>
import FixedHeader from '@/shared/components/FixedHeader';
import { reportsList } from './config';

export default {
  components: {
    FixedHeader
  },
  data() {
    return {
      reportsList
    }
  },
  methods: {
    getLink(token) {
      if (token == 'EMPLOYEE_SALES_COMMISSION_DETAILS' || token == 'EMPLOYEE_PURCHASE_COMMISSION_DETAILS') {
        return `/commission-reports/page?token=${token}`;
      } else {
        return `/reports/page?token=${token}`
      }
    }
  }
  
}
</script>